import * as actionTypes from "../actions/assesmentTestQuestion/actionTypes";
import { LOGOUT_SUCCESSFUL } from "../actions/auth/actionTypes";
import { combineReducers } from "redux";


export const assesmentTestQuestion = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_SUCCESSFUL: {
      return {
        ...state,
      };
    }
    case LOGOUT_SUCCESSFUL: {
      return [];
    }
    default:
      return state;
  }
}

const isFetching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_REQUEST:
      return true;
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_SUCCESSFUL:
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_FAILURE:
      return false;
    default:
      return state;
  }
};
const isUpdating = (state = false, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_ASSESMENT_TEST_QUESTION_REQUEST:
      return true;
    case actionTypes.UPDATE_ASSESMENT_TEST_QUESTION_SUCCESSFUL:
    case actionTypes.UPDATE_ASSESMENT_TEST_QUESTION_FAILURE:
      return false;
    default:
      return state;
  }
};
const isImgLoading = (state = false, action) => {
  switch (action.type) {
    case actionTypes.LOAD_IMG_ASSESMENT_TEST_QUESTION_REQUEST:
      return true;
    case actionTypes.LOAD_IMG_ASSESMENT_TEST_QUESTION_SUCCESSFUL:
    case actionTypes.LOAD_IMG_ASSESMENT_TEST_QUESTION_FAILURE:
      return false;
    default:
      return state;
  }
}


const error = (state=null, action) => {
  switch(action.type){
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_SUCCESSFUL:
    case actionTypes.UPDATE_ASSESMENT_TEST_QUESTION_SUCCESSFUL:
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_REQUEST:
    case actionTypes.UPDATE_ASSESMENT_TEST_QUESTION_REQUEST:
      return null;
    case actionTypes.FETCH_ASSESMENT_TEST_QUESTION_FAILURE:
    case actionTypes.UPDATE_ASSESMENT_TEST_QUESTION_FAILURE:
      return action.error
    default:
      return state;
    }
  }

const assesmentTestQuestionStatus = combineReducers({isFetching, isUpdating, isImgLoading, error});
export default assesmentTestQuestionStatus;
export const getError = (state) => state.error;
export const getIsFetching = (state) => state.isFetching;
export const getIsUpdating = (state) => state.isUpdating;
export const getIsImgLoading = (state) => state.isImgLoading;